<nav class="nav-wrapper">
    <div id="nav" class="nav-bar" [ngClass]="{'apple-device': isNavIOS}">
        
        <div class="back-button" *ngIf="appState.navigation.backButtonState()" (click)="onClickBackButton()">
            <div class="back-icon">
                <app-svg-loader height="24px" url="assets/svg/back-cube.svg"></app-svg-loader>
            </div>
            <div class="back-text">
                Back
            </div>
        </div>

        <div class="left" [ngClass]="{'back-btn-active': appState.navigation.backButtonState()}">
            <div class="nav-brand" (click)="onClickLogo()">
                <app-svg-loader *ngIf="currentTheme === 'dark-theme'" [height]="getLogoSize()" url="assets/logos/tail-one-logo-white.svg"></app-svg-loader>
                <app-svg-loader *ngIf="currentTheme === 'light-theme'" [height]="getLogoSize()" url="assets/logos/tail-one-logo-dark.svg"></app-svg-loader>
            </div>
            <div class="nav-links" *ngIf="!appState.navigation.backButtonState() && appState.agent.mode() !== 'results'">
                <div class="link" *ngFor="let l of navLinks" [ngClass]="{'active': checkLinkActive(l)}">
                    <a (click)="onClickNavLink(l.url)">{{l.name}}</a>
                </div>
            </div>
        </div>

        <div class="right">
            <app-nav-notification-widget></app-nav-notification-widget>
            <app-nav-user-widget></app-nav-user-widget>
        </div>
    </div>
</nav>
